import { render, staticRenderFns } from "./nivel.vue?vue&type=template&id=18b81d10"
import script from "./nivel.vue?vue&type=script&lang=js"
export * from "./nivel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports